export default __webpack_public_path__ + "static/media/emoji-pen.c2c8eb01.svg";